/* eslint-disable @typescript-eslint/no-explicit-any */
const Tarifas = ({ setForm, form }: any) => {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>, value : any) => {
    switch (e.target.name) {
      case "tarifa-limpieza":
        {
          const setTarifas: any[] = form.FEES.filter(
            (fee: { name: string; }) => fee.name !== "Tarifa de limpieza"
          );
          const limpieza = {
            id: value,
            name: "Tarifa de limpieza",
            description: "",
            price: e.target.value,
          };
          setTarifas.push(limpieza);

          setForm({
            ...form,
            FEES: [...setTarifas],
          });
        }
        break;
      case "tarifa-mascota":
        {
          const setTarifas: any[] = form.FEES.filter(
            (fee: { name: string; }) => fee.name !== "Tarifa por mascota"
          );
          const limpieza = {
            id: value,
            name: "Tarifa por mascota",
            description: "",
            price: e.target.value,
          };
          setTarifas.push(limpieza);

          setForm({
            ...form,
            FEES: [...setTarifas],
          });
        }
        break;
      case "tarifa-huesped":
        {
          const setTarifas: any[] = form.FEES.filter(
            (fee: { name: string; }) => fee.name !== "Tarifa por huésped adicional"
          );
          const limpieza = {
            id: value,
            name: "Tarifa por huésped adicional",
            description: "",
            price: e.target.value,
          };
          setTarifas.push(limpieza);

          setForm({
            ...form,
            FEES: [...setTarifas],
          });
        }
        break;
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 py-5 px-5">
      <div>
        <span className="font-bold text-primary mb-2 block">
          Gastos adicionales
        </span>
        <span className="block">Podés cambiarlo cuando quieras.</span>

        <div className="my-3">
          <label className="font-bold">Tarifa de limpieza</label>
          <input
            type="number"
            className="border-0 w-full text-2xl font-bold text-start focus:outline-none hover:border-0 outline-none rounded-md"
            value={
              form.FEES.filter((fee: { name: string; }) => fee.name == "Tarifa de limpieza")[0]
                ?.price || ""
            }
            name="tarifa-limpieza"
            onChange={(event) => onChange(event, form.FEES.filter((fee: { name: string; }) => fee.name == "Tarifa de limpieza")[0]
            ?.id)}
          />
        </div>

        <div className="my-3">
          <label className="font-bold">Tarifa por mascota</label>
          <input
            type="number"
            className="border-0 w-full text-2xl font-bold text-start focus:outline-none hover:border-0 outline-none rounded-md"
            value={
              form.FEES.filter((fee: { name: string; }) => fee.name == "Tarifa por mascota")[0]
                ?.price || ""
            }
            name="tarifa-mascota"
            onChange={(event) => onChange(event, form.FEES.filter((fee: { name: string; }) => fee.name == "Tarifa por mascota")[0]
            ?.id)}
          />
        </div>

        <div className="my-3">
          <label className="font-bold">Tarifa por huésped adicional</label>
          <input
            type="number"
            className="border-0 w-full text-2xl font-bold text-start focus:outline-none hover:border-0 outline-none rounded-md"
            value={
              form.FEES.filter(
                (fee: { name: string; }) => fee.name == "Tarifa por huésped adicional"
              )[0]?.price || ""
            }
            name="tarifa-huesped"
            onChange={(event) => onChange(event, form.FEES.filter(
              (fee: { name: string; }) => fee.name == "Tarifa por huésped adicional"
            )[0]?.id)}
          />
        </div>

        <span className="block">
          Precio para huésped (Sin tarifas): ${form.price}
        </span>
      </div>
      <div></div>
    </div>
  );
};

export default Tarifas;
